import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { type ChildRouteContext } from "@/root";

import ReportViewTable from "@/modules/report/admin/components/report/table/ReportViewTable";
import { fetchReportQueryOptions } from "@/modules/report/admin/services/report";

export const Route = createFileRoute(
  "/admin/_panel/_report/report/reports/view/$id",
)({
  component: RouteComponent,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("View report", { ns: "report.admin" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchReportQueryOptions(opts.params.id),
    ),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
});
function RouteComponent() {
  const { id } = Route.useParams();

  return <ReportViewTable id={id} />;
}
